import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import { InventoryService } from '../../../service/inventory/inventory.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { isSingleOwner } from 'app/menu/header/header.component';

@Component({
  selector: 'app-root',
  templateUrl: 'wa7010.component.html',
  styleUrls: ['wa7010.component.scss']
})
export class Wa7010Component implements AfterViewInit {
  public componentTitle = 'WA7010:棚卸データ作成';
  public owners: any;
  public ownerId: number = 0;
  public inventoryDt: Date;
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private ownerIdCls = '';
  
  private isOwnerFixed = false;
  private isShowSendLoading = false;

  readonly STRINGS_ACTIVE = 'active';


  constructor(
    private router: Router,
    private inventoryService: InventoryService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    console.log(event.target);
  }

  onSubmit() {
    this.errorInfo = '';
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    if (this.ownerId === 0) {
      this.errorInfo = '荷主を選択してください';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    }
    if (this.inventoryDt === undefined) {
      this.errorInfo = '棚卸実施日を選択してください';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    }
    this.inventoryService
      .start(this.ownerId, this.inventoryDt, 'WA7010')
      .then(outputJson => {
        sessionStorage.setItem('SuccessInfoMessage', '棚卸データを作成しました');
        this.errorInfo = '';
        this.ownerId = 0;
        this.inventoryDt = undefined;
        this.isShowSendLoading = false;
        this.working = false;

      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
        this.working = false;
      });
  }

  ngAfterViewInit() {
    sessionStorage.removeItem('isShowOwnerSelect');
    setTimeout(() => {
      this.initOwner();
    }, 500);
    
  }

  initOwner() {
    var ownerResult = sessionStorage.getItem('ownerResult');
    if (ownerResult != null) {
      var ownerJSON = JSON.parse(ownerResult);
      if (ownerJSON.ownerId !== undefined) {
        this.ownerIdCls = this.STRINGS_ACTIVE;
        this.ownerId = ownerJSON.ownerId;

      }
      else {
        this.ownerIdCls = this.ownerId + '' === '0' ? '' : this.STRINGS_ACTIVE
      }
    }
    else {
      this.ownerIdCls = this.ownerId + '' === '0' ? '' : this.STRINGS_ACTIVE
    }
  }
  ngDoCheck() {
    this.initOwner()
    if (isSingleOwner) {
      this.isOwnerFixed = true;
    } else this.isOwnerFixed = false;
  }
  clickOwnerBox() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa7Inventory/wa7010/wa7010.component.ts